export function encodeAndLowercaseDealerLogicalName(logicalName) {
  if (!logicalName) return '';
  return /\s/.test(logicalName) ? encodeURIComponent(logicalName.toLowerCase()) : logicalName.toLowerCase();
}
